<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'AddInvitationCode',
  data() {
    return {
      code: null,
      success: null,
    }
  },
  computed: {
    ...mapState('user', [
      'errors',
    ]),
  },
  methods: {
    ...mapActions('user', [
      'logout',
      'fetchAddInvitationCode',
    ]),
    addInvitationCode() {
      this.fetchAddInvitationCode(this.code)
        .then(res => {
          if (res.id) {
            this.success = true;
            this.code = null;
          }
        })
      ;
    },
  }
};
</script>
<template>
    <div id="login" class="text-center">
        <h1>Dodaj Kod Zaproszenia</h1>
        <div class="wrapper text-left">
            <div class="container d-flex flex-column">
                <label for="code">Kod</label>
                <input id="code" class="mb-3" v-model="code" />

                <div class="errors" v-if="errors.length > 0">
                    <div v-for="error in errors">{{ error }}</div>
                </div>

                <div class="alert-success mt-3 p-3" v-if="success">
                    Kod został dodany do Twojego konta.
                </div>
                <div class="text-center">
                    <button @click="addInvitationCode">
                        Dodaj
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
